import { Controller } from '@hotwired/stimulus'

// Auto-hiding scrollbar: reveal the scrollbar thumb while the user scrolls,
// then fade it out after a short idle delay — mimics the overlay scrollbars
// used by the React (Mantine) sidebar. The scrollbar gutter stays reserved
// (see _sidebar_account.scss) so toggling visibility never shifts the layout.
export default class extends Controller {
  static values = { delay: { type: Number, default: 1200 } }

  connect() {
    this._timeout = null
    this._onScroll = this._onScroll.bind(this)
    this.element.addEventListener('scroll', this._onScroll, { passive: true })
    this._scrollToActive()
  }

  _scrollToActive() {
    requestAnimationFrame(() => {
      const active = this.element.querySelector(
        '.dropdown-item.active, .nav-item.active > .nav-link:not(.dropdown-toggle)',
      )
      if (!active) return
      const container = this.element.getBoundingClientRect()
      const item = active.getBoundingClientRect()
      if (item.top >= container.top && item.bottom <= container.bottom) return
      this.element.scrollTop += item.top - container.top - (this.element.clientHeight - item.height) / 2
    })
  }

  disconnect() {
    this.element.removeEventListener('scroll', this._onScroll)
    if (this._timeout) clearTimeout(this._timeout)
  }

  _onScroll() {
    this.element.classList.add('is-scrolling')
    if (this._timeout) clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.element.classList.remove('is-scrolling'), this.delayValue)
  }
}
